import { render, staticRenderFns } from "./SetupLogo.vue?vue&type=template&id=e7d66554&scoped=true&"
import script from "./SetupLogo.vue?vue&type=script&lang=js&"
export * from "./SetupLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d66554",
  null
  
)

export default component.exports